import { module } from 'angular';

import { default as lyncServiceName, LyncService } from './lync.service';

export default module('contact.agent.core.channel-digit.softphone.lync', []).service(lyncServiceName, LyncService).name;
